/**
 * How far a hull card leans toward the pointer (life-layer.md §3 P4: ±6°).
 *
 * Pure: the pointer's place in the card in, two angles out. "Toward" means the
 * edge under the pointer comes forward, which in CSS is a negative `rotateX`
 * for the top edge and a negative `rotateY` for the right edge.
 */

/** Largest lean either way, in degrees (life-layer.md §3 P4). */
export const TILT_MAX_DEG = 6;

export interface Tilt {
  rx: number;
  ry: number;
}

function clamp(v: number): number {
  return Math.min(1, Math.max(-1, v));
}

export function tiltFor(
  x: number,
  y: number,
  rect: { left: number; top: number; width: number; height: number },
  maxDeg = TILT_MAX_DEG,
): Tilt {
  if (rect.width <= 0 || rect.height <= 0) return { rx: 0, ry: 0 };
  const nx = clamp(((x - rect.left) / rect.width) * 2 - 1);
  const ny = clamp(((y - rect.top) / rect.height) * 2 - 1);
  // `+ 0` folds -0 into 0 so a centred pointer reads as no lean.
  return { rx: ny * maxDeg + 0, ry: -nx * maxDeg + 0 };
}
